// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"587":"48fccf03","613":"395802e1","797":"1fc6823f","896":"2d28333e"}[chunkId] + ".css";
};